module.exports = __webpack_public_path__ + "static/media/partner-strengths.b3bb19d2.svg";